import { req } from 'vuelidate/lib/validators/common';
import cardValidator from 'card-validator';

// Utils
import _ from 'lodash';

export default (number) => {
  const type = _.get(cardValidator.number(number), 'card.type');
  const getLengthNumber = number.toString().length;
  if (number !== '') {
    if (type === 'visa' && getLengthNumber === 13) {
      let validVisa = true;
      return !req(number) || validVisa;
    }
  }
  return !req(number) || cardValidator.number(number).isValid;
}



// WEBPACK FOOTER //
// ./src/components/customValidation/cardNumber.js